import { Button } from "$components/button/button";
import { PlusIconBorderless } from "$components/icons";
import React from "react";
import { FormattedMessage } from "react-intl";

interface AddPrescriptionButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

const AddPrescriptionButton = ({
  onClick: handleClick,
  disabled = false,
}: AddPrescriptionButtonProps): React.ReactElement => {
  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleClick}
      disabled={disabled}
      data-testid="outpatient.prescription.addPrescriptionButton"
      startIcon={<PlusIconBorderless color="primary" />}
    >
      <FormattedMessage
        id="investigations.initialForm.addPrescription"
        defaultMessage="Prescription"
      />
    </Button>
  );
};

export default AddPrescriptionButton;
